/**
 * As letras de um avatar — UMA regra para o painel inteiro.
 *
 * Só palavras que começam por LETRA: o cartão do funil passa o rótulo do contato
 * ("Jõao · +5598…") e a conta antiga pegava o "+" do telefone ("J+"), enquanto a
 * conversa da mesma pessoa mostrava "J". Primeira e última palavra, como sempre.
 */
export function initials(name: string | null | undefined): string {
	const words = (name ?? "").split(/[\s·]+/).filter((w) => /^\p{L}/u.test(w));
	const first = words[0]?.[0] ?? "";
	const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? "") : "";
	return (first + last).toUpperCase() || "?";
}
